import React, {useMemo} from 'react';
import {CardHeader, Card, CardHeaderToolbar, CardBody} from "../../../../../_metronic/_partials/controls";
import {InvestigationsTable} from "./investigations-table/InvestigationsTable";
import {useInvestigationsUIContext} from "./InvestigationsUIContext";
import {HasCreateAccess, IsSuperUser} from "../../../../../_metronic/_helpers/AccessControlHelpers";
import {useSelector} from "react-redux";
import {INVESTIGATION_MODEL} from "../../../../../_metronic/_helpers/AppModels";

export function InvestigationsCard(){

    const {user} = useSelector((state) => state.auth);

    const investigationsUiContext = useInvestigationsUIContext();

    const investigationsUIProps = useMemo(() => (
        {
            newInvestigationButtonClick: investigationsUiContext.newInvestigationButtonClick
        }
    ), [investigationsUiContext])

    return(
        <Card>
            <CardHeader title={"لیست بازرسی ها"}>
                {(HasCreateAccess(user, INVESTIGATION_MODEL) || IsSuperUser(user)) && (
                    <CardHeaderToolbar>
                        <button
                            type={"button"}
                            className={"btn btn-primary"}
                            onClick={investigationsUIProps.newInvestigationButtonClick}>
                            ایجاد بازرسی
                        </button>

                    </CardHeaderToolbar>
                )}
            </CardHeader>
            <CardBody>

                <InvestigationsTable/>
            </CardBody>
        </Card>
    )


}